import SelectOptionsApi from '@api/SelectOptionsApi'

export const selectOptionsFromApi = {
  namespaced: true,
  state: {
    requesting: {},
    genders: [],
    relationships: [],
    ethnicities: [],
    spokenWrittenLanguages: [],
    races: []
  },
  mutations: {
    SET_REQUESTING(state, requesting) {
      state.requesting = requesting
    },
    SET_GENDERS(state, genders) {
      state.genders = genders
    },
    SET_RELATIONSHIPS(state, relationships) {
      state.relationships = relationships
    },
    SET_ETHNICITIES(state, ethnicities) {
      state.ethnicities = ethnicities
    },
    SET_SPOKEN_WRITTEN_LANGUAGES(state, spokenWrittenLanguages) {
      state.spokenWrittenLanguages = spokenWrittenLanguages
    },
    SET_RACES(state, races) {
      state.races = races
    }
  },
  actions: {
    GET_GENDERS({ commit, state }) {
      if (state.requesting['genders']) {
        return
      }

      commit('SET_REQUESTING', { ...state.requesting, ...{ genders: true } })

      new SelectOptionsApi({ simulateExample: 'Get Genders' }).genders()
        .then(res => {
          commit('SET_GENDERS', res)
        })
        .finally(() => {
          commit('SET_REQUESTING', { ...state.requesting, ...{ genders: false } })
        })
    },
    GET_RACES({ commit, state }) {
      if (state.requesting['races']) {
        return
      }

      commit('SET_REQUESTING', { ...state.requesting, ...{ races: true } })

      new SelectOptionsApi({ simulateExample: 'Race' }).races()
        .then(res => {
          commit('SET_RACES', res)
        })
        .finally(() => {
          commit('SET_REQUESTING', { ...state.requesting, ...{ races: false } })
        })
    },
    GET_RELATIONSHIPS({ commit, state }) {
      if (state.requesting['relationships']) {
        return
      }

      commit('SET_REQUESTING', { ...state.requesting, ...{ relationships: true } })

      new SelectOptionsApi({ simulateExample: 'Get RelationShips' }).relationships()
        .then(res => {
          commit('SET_RELATIONSHIPS', res)
        })
        .finally(() => {
          commit('SET_REQUESTING', { ...state.requesting, ...{ relationships: false } })
        })
    },
    GET_ETHNICITIES({ commit, state }) {
      if (state.requesting['ethnicities']) {
        return
      }

      commit('SET_REQUESTING', { ...state.requesting, ...{ ethnicities: true } })

      new SelectOptionsApi({ simulateExample: 'ethnicity' }).ethnicities()
        .then(res => {
          commit('SET_ETHNICITIES', res)
        })
        .finally(() => {
          commit('SET_REQUESTING', { ...state.requesting, ...{ ethnicities: false } })
        })
    },
    GET_SPOKEN_WRITTEN_LANGUAGES({ commit, state }) {
      if (state.requesting['spokenWrittenLanguages']) {
        return
      }

      commit('SET_REQUESTING', { ...state.requesting, ...{ spokenWrittenLanguages: true } })

      new SelectOptionsApi({ simulateExample: 'Spoken & Written Language' }).languages()
        .then(res => {
          commit('SET_SPOKEN_WRITTEN_LANGUAGES', res)
        })
        .finally(() => {
          commit('SET_REQUESTING', { ...state.requesting, ...{ spokenWrittenLanguages: false } })
        })
    }
  }
}
